import  NetworkHandler from 'utils/network';
import config from 'config';

function getCompanyById(id) {
    return NetworkHandler.get(`${config.getUrl('bus_companies')}/${id}`);
}


export default {
    getCompanyById,
};
